import React from 'react';
import { bemClasses } from '../helpers';
export var Href = function (_a) {
    var href = _a.href, children = _a.children;
    var className = "anchor";
    return (React.createElement("a", { href: href, target: "_blank", rel: "nofollow noopener noreferrer", className: bemClasses.element(className) },
        React.createElement("div", { className: bemClasses.element(className + "-content") }, children),
        React.createElement("span", { className: bemClasses.element(className + "-icon") })));
};
//# sourceMappingURL=Href.js.map